import React from 'react';
import Footer from 'blocks/footer';
import NotFound from './NotFound';

import './page-error.scss';

export default () => (
  <div>
    <div className="content content_main">
      <NotFound hint />
    </div>
    <Footer big />
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/404/NotFoundPage.js